import { render, staticRenderFns } from "./GoiMap.vue?vue&type=template&id=704d991c&scoped=true"
import script from "./GoiMap.vue?vue&type=script&lang=js"
export * from "./GoiMap.vue?vue&type=script&lang=js"
import style0 from "./GoiMap.vue?vue&type=style&index=0&id=704d991c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704d991c",
  null
  
)

export default component.exports